import React, { useRef } from 'react';
import logo from '../assets/log.png';
import avatar from '../assets/avatar-blank.jpg';
// import { NavLink } from 'react-router-dom';

function Header({ show_search }) {
	const inputRef = useRef(null);
	const name = JSON.parse(sessionStorage.getItem('user', {}));
	const logout = (e) => {
		e.preventDefault();
		sessionStorage.clear();
		window.location.replace('/');
	};

	function handleClick() {
		if (inputRef.current.value.length > 0) {
			window.location.replace(
				`${window.location.pathname}?s=${inputRef.current.value}`
			);
			inputRef.current.value = null;
		}
	}

	return (
		<nav className="navbar header-navbar pcoded-header">
			<div className="navbar-wrapper">
				<div className="navbar-logo">
					<a href="/dashboard">
						<img
							className="img-fluid"
							src={logo}
							width="40"
							alt="Theme-Logo"
						/>
						{/* <span className="p-l-10 f-18 o-auto">HYDRODRIP</span> */}
					</a>
					<a className="mobile-menu" id="mobile-collapse" href="#!">
						<i className="feather icon-menu icon-toggle-right"></i>
					</a>

					<a className="mobile-options waves-effect waves-light">
						<i className="feather icon-more-horizontal"></i>
					</a>
				</div>
				<div className="navbar-container container-fluid">
					{show_search && (
						<ul className="nav-left">
							<li className="header-search">
								<div className="main-search morphsearch-search">
									<div className="input-group">
										<span className="input-group-text search-close">
											<i className="feather icon-x input-group-text"></i>
										</span>
										<input
											ref={inputRef}
											type="text"
											className="form-control"
											placeholder="Enter Keyword"
										/>
										<span
											onClick={handleClick}
											className="input-group-text search-btn"
										>
											<i className="feather icon-search input-group-text"></i>
										</span>
									</div>
								</div>
							</li>
						</ul>
					)}
					<ul className="nav-right">
						{/* <li className="header-notification">
							<div className="dropdown-primary dropdown">
								<div
									className="dropdown-toggle"
									data-bs-toggle="dropdown"
								>
									<i className="feather icon-bell"></i>
									<span className="badge bg-c-red">5</span>
								</div>
								<ul
									className="show-notification notification-view dropdown-menu"
									data-dropdown-in="fadeIn"
									data-dropdown-out="fadeOut"
								>
									<li>
										<h6>Notifications</h6>
										<label className="form-label label label-danger">
											New
										</label>
									</li>
									<li>
										<div className="d-flex">
											<div className="flex-shrink-0">
												<img
													className="img-radius"
													src="%PUBLIC_URL%/files/assets/images/avatar-blank.jpg"
													alt="Generic placeholder image"
												/>
											</div>
											<div className="flex-grow-1">
												<h5 className="notification-user">
													John Doe
												</h5>
												<p className="notification-msg">
													Lorem ipsum dolor sit amet,
													consectetuer elit.
												</p>
												<span className="notification-time">
													30 minutes ago
												</span>
											</div>
										</div>
									</li>
									<li>
										<div className="d-flex">
											<div className="flex-shrink-0">
												<img
													className="img-radius"
													src="../files/assets/images/avatar-3.jpg"
													alt="Generic placeholder image"
												/>
											</div>
											<div className="flex-grow-1">
												<h5 className="notification-user">
													Joseph William
												</h5>
												<p className="notification-msg">
													Lorem ipsum dolor sit amet,
													consectetuer elit.
												</p>
												<span className="notification-time">
													30 minutes ago
												</span>
											</div>
										</div>
									</li>
									<li>
										<div className="d-flex">
											<div className="flex-shrink-0">
												<img
													className="img-radius"
													src="../files/assets/images/avatar-blank.jpg"
													alt="Generic placeholder image"
												/>
											</div>
											<div className="flex-grow-1">
												<h5 className="notification-user">
													Sara Soudein
												</h5>
												<p className="notification-msg">
													Lorem ipsum dolor sit amet,
													consectetuer elit.
												</p>
												<span className="notification-time">
													30 minutes ago
												</span>
											</div>
										</div>
									</li>
								</ul>
							</div>
						</li> */}
						<li className="user-profile header-notification">
							<div className="dropdown-primary dropdown">
								<div
									className="dropdown-toggle"
									data-bs-toggle="dropdown"
								>
									<img
										src={avatar}
										className="img-radius"
										alt="User-Profile-Image"
									/>

									<span>{name?.fullName}</span>
									<i className="feather icon-chevron-down"></i>
								</div>
								<ul
									className="show-notification profile-notification dropdown-menu"
									data-dropdown-in="fadeIn"
									data-dropdown-out="fadeOut"
								>
									<li>
										<a href="/settings">
											<i className="feather icon-settings"></i>{' '}
											Settings
										</a>
									</li>
									<li>
										<a
											href={`/administrators/users/edit/${name?.id}`}
										>
											<i className="feather icon-user"></i>{' '}
											Profile
										</a>
									</li>
									<li onClick={logout}>
										<a href="#!">
											<i className="feather icon-log-out"></i>{' '}
											Logout
										</a>
									</li>
								</ul>
							</div>
						</li>
					</ul>
				</div>
			</div>
		</nav>
	);
}

export default Header;
